import React from 'react';
import { Box } from 'edenred-ui';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';

import { AutomaticRepeatCheckbox } from '@epi-containers/ManageBenefitGroups/components/AutomaticRepeatCheckbox';
import { useFormContext } from 'react-hook-form';
import { ICreateBenefitGroupForm } from '@epi-models/pages/BenefitGroups';
import { FundsLoadingTypes } from '@epi-constants/benefitTypes';

const BenefitGroupSettings = () => {
  const { sizeMedium, fontSemiBold } = useTheme();
  const { t } = useTranslation();

  const { watch } = useFormContext<ICreateBenefitGroupForm>();
  const fundsLoadingType = watch('benefitSettings.lunch.fundsLoadingType');

  if (fundsLoadingType !== FundsLoadingTypes.TopUpRequest) {
    return null;
  }

  return (
    <Box p={3}>
      <Box fontSize={sizeMedium} fontWeight={fontSemiBold} pb={2}>
        {t('containers.benefit_groups.benefit_group_settings')}
      </Box>
      <AutomaticRepeatCheckbox
        disabled={false}
        name={`benefitSettings.lunch.recurringTopupRequestEnabled`}
      />
    </Box>
  );
};

export { BenefitGroupSettings };
